
import { api_host,api_auth} from '../../common/globals/constants';

export const getElements = (objective, monitor, step, token, id_user, date) => 
fetch(api_host+`/reporte/online/indicadores/getElementsPlusStep/?user=${id_user}&token=${token}&objetivoId=${objective}&fecha=${date}&paso=${step}&monitor_id=${monitor}`)
.then(response => response.json())
